import { Stack } from "@mantine/core"
import { CountrySelector, LabelWithTooltip } from "@tfg/ui"

import { FormFieldConfig } from "~/pages/Admin/components/form.types"
import { COUNTRIES } from "~/utils/countries"

export const CountrySelectField = (fields: FormFieldConfig, form: any) => (
  <Stack gap="var(--mantine-spacing-xxs)">
    {fields.tooltip && (
      <LabelWithTooltip
        label={fields.label}
        hoverHelperText={fields.tooltip}
        justify="space-between"
        fw={600}
        withAsterisk={fields.required ?? false}
      />
    )}
    <CountrySelector
      searchable
      countriesMapper={COUNTRIES}
      key={fields.name}
      label={!fields.tooltip ? fields.label : undefined}
      placeholder={fields.placeholder}
      classNames={fields.customClass}
      labelProps={{
        fz: "xs",
        fw: 600,
      }}
      {...form.getInputProps(fields.name)}
      onChange={(value) => {
        form.setFieldValue(fields.name, value)
        form.validateField(fields.name)
      }}
      error={!form.isValid(fields.name) && form.isTouched()}
      disabled={fields.disabled}
    />
  </Stack>
)
